import {UPDATE_CLIENT_VIEW_PORT} from '../../actions/actionTypes';

export function clientViewPortReducer(state = {}, action) {
    state.lastChange = new Date().getTime(); //update state without cloing it
    switch (action.type) {
        case UPDATE_CLIENT_VIEW_PORT:
            return Object.assign({}, action.visible);

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/common/clientViewPortReducer.js